export default __webpack_public_path__ + "546cc590463eb4e930d9fc1198792d7a.png";